// src/storeVisits/index.js
//
// Entry point for the Store Visit Reports feature bundle.
// Built by build.js → dist/storeVisits.js, loaded by admin.html.
//
// Phase 1 (v112.0): visit targets admin tab.
// Phase 2 (v113.x): + visit CRUD, photos, detailed/short form, launcher.
// Phase 3 (v114+):  + reporting dashboards (AM performance, aggregates).
//
// Each sub-module sets window.* side effects on load (per ELC Shift module
// convention) so inline HTML callers work without namespace changes.

export * from './visitTargets.js';
export * from './monthlyEmail.js';   // v131.13 - the monthly SVR email panel
export * from './form-spec.js';
export * from './elcShiftEmbed.js';
export * from './photoUpload.js';
export * from './form-detailed.js';
export * from './form-short.js';
export * from './newVisit.js';
export * from './storeVisitView.js';
export * from './storeVisitReports.js';
export * from './storeVisitCadence.js';
export * from './storeVisitInsights.js';
import './templateEditor.js';
